export const MAX_PASSWORD_LENGTH = 32;

export const passwordIsValid = (password?: string) => {
  const regexp = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^[a-zA-Z!"#$%&'()*+,-.\/:;<=>?@\[\\\]^_`{|}~\d]+$/gm,
  );
  return regexp.test(password || '');
};

export const getPasswordValidateMessage = (
  password?: string,
): string | undefined => {
  if (!password) {
    return 'Необходимо указать пароль';
  }

  if (password?.length > MAX_PASSWORD_LENGTH) {
    return `Пароль не может быть длиннее ${MAX_PASSWORD_LENGTH} символов`;
  }

  return passwordIsValid(password)
    ? undefined
    : 'Пароль содержит запрещенные символы';
};
